module.exports = __webpack_public_path__ + "img/swiper2.191a592d.jpg";